import mitt from "mitt"

export const EVENTS = {
    SHOW_FLASH: "SHOW_FLASH",
    HIDE_FLASH: "HIDE_FLASH",
    OPEN_MOBILE_MENU: "OPEN_MOBILE_MENU"
}

const EventBus = mitt()

export default EventBus
